import { create } from 'zustand';
import { toast } from 'sonner';
import { timerAPI } from './api';

const fmt = (m) => (m >= 60 ? `${Math.floor(m / 60)} h ${m % 60} min` : `${m} min`);

// Estado del cronómetro: lo manda el servidor (hora de inicio), la pantalla solo lo pinta.
export const useTimerStore = create((set, get) => ({
  active: null, todayMinutes: 0, offsetMs: 0, loaded: false, busy: false, myTimeOpen: false,
  apply: (r) => set({ active: r.active, todayMinutes: r.today_minutes || 0, loaded: true,
    offsetMs: r.server_now ? new Date(r.server_now).getTime() - Date.now() : get().offsetMs }),
  refresh: async () => { try { get().apply(await timerAPI.me()); } catch { /* sin sesión */ } },
  start: async (taskId) => {
    set({ busy: true });
    try {
      const r = await timerAPI.start(taskId);
      get().apply(r);
      if (r.stopped) toast.info(`Has parado «${r.stopped.task_title}» (${fmt(r.stopped.minutes)}) y arrancado «${r.active?.task_title}»`);
      else toast.success('Cronómetro en marcha');
      return true;
    } catch (e) { toast.error(e.message || 'No se pudo iniciar'); return false; } finally { set({ busy: false }); }
  },
  stop: async () => {
    set({ busy: true });
    try {
      const r = await timerAPI.stop();
      get().apply(r);
      if (r.stopped) toast.success(`Tiempo registrado: ${fmt(r.stopped.minutes)} en «${r.stopped.task_title}»`);
    } catch (e) { toast.error(e.message || 'No se pudo parar'); } finally { set({ busy: false }); }
  },
  keepalive: async () => { try { get().apply(await timerAPI.keepalive()); toast.success('Perfecto, sigue en marcha'); } catch (e) { toast.error(e.message); } },
  setMyTimeOpen: (v) => set({ myTimeOpen: v }),
}));

export const elapsedSeconds = (active, offsetMs) =>
  active ? Math.max(0, Math.floor((Date.now() + offsetMs - new Date(active.started_at).getTime()) / 1000)) : 0;

export const fmtClock = (sec) => {
  const h = Math.floor(sec / 3600), m = Math.floor((sec % 3600) / 60), s = sec % 60;
  return `${h}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
};
export const fmtMinutes = fmt;
